import assetSercvice from './ws';

export default assetSercvice;
